var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBuscador(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 22",
    style: {
      enableBackground: "new 0 0 22 22"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3D378C;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.2,18.2c-1.2,0-2.4-0.2-3.5-0.7c-1.1-0.5-2.1-1.1-2.9-1.9c-0.8-0.8-1.5-1.8-1.9-2.9 c-0.5-1.1-0.7-2.3-0.7-3.5s0.2-2.4,0.7-3.5c0.5-1.1,1.1-2.1,1.9-2.9c0.8-0.8,1.8-1.5,2.9-1.9C6.7,0.2,7.9,0,9.2,0s2.4,0.2,3.5,0.7 c1.1,0.5,2.1,1.1,2.9,1.9c0.8,0.8,1.5,1.8,1.9,2.9c0.5,1.1,0.7,2.3,0.7,3.5s-0.2,2.4-0.7,3.5c-0.5,1.1-1.1,2.1-1.9,2.9 c-0.8,0.8-1.8,1.5-2.9,1.9C11.6,18,10.4,18.2,9.2,18.2z M9.2,2.7c-3.5,0-6.4,2.9-6.4,6.4c0,3.5,2.9,6.4,6.4,6.4 c3.5,0,6.4-2.9,6.4-6.4C15.5,5.6,12.7,2.7,9.2,2.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.1,22c-0.5,0-1-0.2-1.3-0.6l-5-5.2c-0.7-0.7-0.7-1.9,0.1-2.6c0.7-0.7,1.9-0.7,2.6,0.1l5,5.2 c0.7,0.7,0.7,1.9-0.1,2.6C21,21.8,20.5,22,20.1,22z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBuscador);
export default __webpack_public_path__ + "static/media/icon-buscador.2b6cc0c6583e12e94c4b004895cd991f.svg";
export { ForwardRef as ReactComponent };